"use strict";
/**
 * This module provides the UI for the toolbar.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents a drawing operation that the user can select from the toolbar.
 */
var DrawingOperation = /** @class */ (function () {
    function DrawingOperation(name, properties) {
        this.name = name;
        this.definition = properties.definition;
    }
    /**
     * Creates a CSS class name. Name is lower case with hyphen (-) separated words.
     * @returns {string}
     */
    DrawingOperation.prototype.toClassName = function () {
        return this.name.replace("_", "-").toLowerCase();
    };
    /**
     * Creates a button for the drawing operation.
     * @returns {HTMLButtonElement}
     */
    DrawingOperation.prototype.createDrawUIButton = function () {
        var button = document.createElement("button");
        button.type = "button";
        button.value = this.name;
        button.title = this.definition;
        button.disabled = this.name === "TEXT";
        button.classList.add(this.toClassName());
        var iconSpan = document.createElement("span");
        iconSpan.classList.add("icon");
        button.appendChild(iconSpan);
        var labelSpan = document.createElement("span");
        labelSpan.classList.add("label");
        labelSpan.textContent = this.toClassName();
        button.appendChild(labelSpan);
        return button;
    };
    return DrawingOperation;
}());
exports.DrawingOperation = DrawingOperation;
// Convert generic objects to DrawingOperation objects.
/**
 * Provides info about available drawing operations represented
 * in the UI buttons.
 */
var drawingOperations = (function (ops) {
    var output = {};
    for (var name_1 in ops) {
        if (ops.hasOwnProperty(name_1)) {
            output[name_1] = new DrawingOperation(name_1, ops[name_1]);
        }
    }
    return output;
})({
    TEXT: { definition: "Adds a text label" },
    POINT: { definition: "Draws a point." },
    MULTI_POINT: { definition: "Draws a Multipoint." },
    LINE: { definition: "Draws a line." },
    POLYLINE: { definition: "Draws a polyline." },
    FREEHAND_POLYLINE: { definition: "Draws a freehand polyline." },
    POLYGON: { definition: "Draws a polygon." },
    FREEHAND_POLYGON: { definition: "Draws a freehand polygon." },
    CIRCLE: { definition: "Draws a circle." },
    EXTENT: { definition: "Draws an extent box." },
    RECTANGLE: { definition: "Draws a rectangle." },
    ELLIPSE: { definition: "Draws an ellipse." },
    TRIANGLE: { definition: "Draws a triangle." },
    ARROW: { definition: "Draws an arrow." },
    UP_ARROW: { definition: "Draws an arrow that points up." },
    LEFT_ARROW: { definition: "Draws an arrow that points left." },
    RIGHT_ARROW: { definition: "Draws an arrow that points right." },
    DOWN_ARROW: { definition: "Draws an arrow that points down." },
    CLEAR: { definition: "Deletes the user-drawn graphics." }
});
exports.drawingOperations = drawingOperations;
// tslint:disable-next-line:max-classes-per-file
var DrawUI = /** @class */ (function () {
    /**
     * Creates a toolbar UI for drawing graphics on a map.
     * @param {HTMLElement} rootDiv - An HTML container element, e.g., <div>, <nav>.
     * @class
     */
    function DrawUI(root) {
        this.root = root;
        var rootDiv = this.root;
        rootDiv.classList.add("draw-ui");
        var docFrag = document.createDocumentFragment();
        for (var name_2 in drawingOperations) {
            if (drawingOperations.hasOwnProperty(name_2)) {
                var button = drawingOperations[name_2].createDrawUIButton();
                docFrag.appendChild(button);
            }
        }
        // docFrag.appendChild(button);
        rootDiv.appendChild(docFrag);
        var textbox = document.createElement("input");
        textbox.type = "text";
        textbox.name = "label";
        textbox.placeholder = "label for text goes here";
        var textButton = rootDiv.querySelector("button[value='TEXT']");
        textbox.addEventListener("change", function () {
            textButton.disabled = !Boolean(this.value);
        });
        rootDiv.insertBefore(textbox, rootDiv.firstChild);
    }
    return DrawUI;
}());
exports.default = DrawUI;
